import React from 'react'
import Typography from '../../../components/Basics/Typography'
import { skills } from '../content/profile.content'
import {
  Category,
  CategoryTitle,
  Container,
  Grid,
  Item,
  ItemList,
} from './Skills.styles'

const Skills = () => {
  return (
    <Container id="skills">
      <Typography variant="h1">Skills</Typography>
      <Grid>
        {skills.map((group) => (
          <Category key={group.category}>
            <CategoryTitle>{group.category}</CategoryTitle>
            <ItemList>
              {group.items.map((item) => (
                <Item key={item}>{item}</Item>
              ))}
            </ItemList>
          </Category>
        ))}
      </Grid>
    </Container>
  )
}

export default Skills
